import { useQuery } from '@tanstack/react-query';
import { fetcher } from '../libs';

export default function useCheckOnboardingQuery() {
  return useQuery(['accounts', 'onboard'], async () => {
    return fetcher<boolean>('/accounts/onboarding');
  });
}
